import { render, staticRenderFns } from "./FormShipToAddress.vue?vue&type=template&id=542c90ef&"
import script from "./FormShipToAddress.vue?vue&type=script&lang=js&"
export * from "./FormShipToAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports